import qs from 'querystring';
import cookies from 'js-cookie';
import { NIKE_API_CALLER_ID } from 'nav-utilities';
import { URL } from '../constants';

/**
 * Map of keyword: data for caching visual search responses.
 * Makes it so the API does not need to be hit again if tabbing through suggestions.
 * @type {Object}
 */
export const cache = {
  visualSearches: {},
};

/**
 * Returns the anonymousID if it is present in the cookies
 * @param {Object} c containing cookies
 * @returns {Object} with {anonymous-id: id} string or {} if none exists
 */
export function getAnonymousId(c = cookies) {
  const anonymousId = c.get('anonymousId');
  return anonymousId ? { 'anonymous-id': anonymousId } : {};
}

/**
 * Perform a visual search lookup.
 * @param term {String}
 * @param opts {Object}
 * @returns {Promise}
 */
export async function search(term, opts) {
  const { useCache = false, country, language } = opts;
  const keyword = term.toLowerCase();
  if (useCache && cache.visualSearches[keyword]) {
    return cache.visualSearches[keyword];
  }
  const endpoint = `/search_preview/v1/marketplace/${country.toUpperCase()}/language/${language}/consumerChannelId/d9a5bc42-4b9c-4976-858a-f159cf99c647`;
  const query = qs.stringify({
    searchTerm: keyword,
  });
  const headers = { 'nike-api-caller-id': NIKE_API_CALLER_ID };
  const data = await fetch(`${URL.API_DISCOVER}${endpoint}?${query}`, {
    headers,
  }).then(res => res.json());
  cache.visualSearches[keyword] = data;
  return data;
}

/**
 * Perform a text suggestions lookup.
 * @param term {String}
 * @param opts {Object}
 * @returns {Promise}
 */
export async function suggestions(term, opts) {
  const { country, language, count } = opts;

  if (!(term || count)) {
    return null;
  }
  let queryObject = {
    country: country.toUpperCase(),
    language: language.toLowerCase(),
    ...(term && { text: term }),
    ...(count && { count: count }),
  };

  const query = qs.stringify(queryObject);
  const anonymousId = getAnonymousId();
  const headers = {
    Accept: 'application/json; charset=UTF-8',
    'nike-api-caller-id': NIKE_API_CALLER_ID,
    ...anonymousId,
  };
  const res = await fetch(`${URL.API_SEARCH}/suggestions/v1?${query}`, {
    headers,
  });
  return await res.json();
}
